import { gql } from '@apollo/client'
import { SABRE_BRAND_FRAGMENT } from './BrandFragment'
import { CATEGORY_FRAGMENT } from './CategoryFragment'
import { SABRE_FLAVOR_FRAGMENT } from './FlavorFragment'
import { IMAGE_FRAGMENT } from './ImageFragment'
import { SABRE_MANUFACTURER_FRAGMENT } from './ManufacturerFragment'
import { SABRE_PACKAGING_FRAGMENT } from './PackagingFragment'
import { SABRE_PRODUCT_FRAGMENT } from './ProductFragment'
import { SABRE_SHIPPING_FRAGMENT } from './ShippingFragment'

export const DRAFT_PRODUCT_FRAGMENT = gql`
  fragment DraftProduct on DraftProduct {
    id
    name
    createdBy
    dateResolved
    fieldsAccepted
    notes
    shipping {
      ...Shipping
    }
    category {
      ...Category
    }
    brand {
      ...Brand
    }
    packaging {
      ...Packaging
    }
    manufacturer {
      ...Manufacturer
    }
    flavors {
      ...Flavor
    }
    product {
      ...Product
    }
  }
  ${IMAGE_FRAGMENT}
  ${SABRE_BRAND_FRAGMENT}
  ${SABRE_FLAVOR_FRAGMENT}
  ${CATEGORY_FRAGMENT}
  ${SABRE_PACKAGING_FRAGMENT}
  ${SABRE_SHIPPING_FRAGMENT}
  ${SABRE_PRODUCT_FRAGMENT}
  ${SABRE_MANUFACTURER_FRAGMENT}
`
